import type { FC } from 'react';

import type { FacetedFilter, FilterGridRow } from '@shared/api/findings/findings.types';

import { FieldCard } from './FieldCard';

interface FilterGridProps {
  filters: FacetedFilter[];
  selectedFields: string[];
  toggleField: (key: string) => void;
  forceZeroCount?: boolean;
}

const FILTER_COLUMNS = 3;

export const FilterGrid: FC<FilterGridProps> = ({ filters, selectedFields, toggleField, forceZeroCount = false }) => {
  const sorted = [...filters].sort((a, b) => {
    const labelA = a.label ?? '';
    const labelB = b.label ?? '';
    return labelA.localeCompare(labelB);
  });
  const rows = Math.ceil(sorted.length / FILTER_COLUMNS);
  const flatGrid: FilterGridRow = [];
  for (let rowIdx = 0; rowIdx < rows; rowIdx++) {
    for (let colIdx = 0; colIdx < FILTER_COLUMNS; colIdx++) {
      const idx = colIdx * rows + rowIdx;
      if (idx < sorted.length) {
        flatGrid.push(sorted[idx]);
      }
    }
  }
  return (
    <div className="grid grid-cols-3 gap-x-6 gap-y-2" data-testid="filter-grid-root">
      {flatGrid.map((filter, idx) => {
        if (!filter) return null;
        const count = forceZeroCount ? 0 : filter.options.filter((opt) => (opt.count ?? 0) > 0).length;
        return (
          <FieldCard
            key={`${filter.key}-${idx}`}
            field={filter.label}
            count={count}
            selected={selectedFields.includes(filter.key)}
            onToggle={() => toggleField(filter.key)}
          />
        );
      })}
    </div>
  );
};
